/**
 * AIM's sound set. Playback is injected by each app because the audio APIs
 * differ per platform (expo-av on iOS, a native module on macOS/Windows), and
 * the shared screens must not depend on any of them.
 *
 * Until an app calls `setSoundPlayer`, every cue is a silent no-op — which is
 * also the correct behaviour when the user turns sounds off.
 */
export type SoundName =
  | 'imReceive'
  | 'imSend'
  | 'buddyIn'
  | 'buddyOut'
  | 'signOn'
  | 'signOff'
  | 'buzz'
  | 'error';

export type SoundPlayer = (name: SoundName) => void;

let player: SoundPlayer | null = null;
let enabled = true;

export function setSoundPlayer(fn: SoundPlayer | null): void {
  player = fn;
}

export function setSoundsEnabled(on: boolean): void {
  enabled = on;
}

export function areSoundsEnabled(): boolean {
  return enabled;
}

export function play(name: SoundName): void {
  if (!enabled || !player) return;
  try {
    player(name);
  } catch {
    // A failed sound must never break a message send.
  }
}
